import { useState } from 'react';
import firebase from 'firebase/compat/app';

const functions = firebase.functions();

/**
 * Batch Activate Modal - Confirm and execute batch template activation
 */
export function BatchActivateModal({ templates, onClose, onSuccess }) {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);

    try {
      const templateIds = templates.map(t => t.id);
      const batchActivateTemplates = functions.httpsCallable('batchActivateTemplates');
      const result = await batchActivateTemplates({ templateIds });

      onSuccess(result.data);
    } catch (error) {
      // console statement removed for production
      onSuccess({
        successCount: 0,
        failureCount: templates.length,
        failedTemplates: templates.map(t => t.title)
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Vorlagen aktivieren</h2>
          <button className="modal-close" onClick={onClose} disabled={loading}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="modal-body">
          <p>Möchten Sie {templates.length} Vorlagen aktivieren?</p>
          <p className="modal-info-text">
            Für jede Vorlage wird eine erste Aufgaben-Instanz erstellt.
          </p>
        </div>

        <div className="modal-actions">
          <button type="button" onClick={onClose} disabled={loading}>
            Abbrechen
          </button>
          <button
            type="button"
            className="btn-success"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? 'Aktiviere...' : 'Aktivieren'}
          </button>
        </div>
      </div>
    </div>
  );
}
